module.exports = __webpack_public_path__ + "static/img/redeem.a55d8bd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zh-TW/redeem.png
// module id = Bc0/
// module chunks = 1